/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showless1Inputs */

const en_showless1 = /** @type {(inputs: Showless1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show less`)
};

const de_showless1 = /** @type {(inputs: Showless1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger anzeigen`)
};

/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Showless1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const showless1 = /** @type {((inputs?: Showless1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showless1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_showless1(inputs)
	return de_showless1(inputs)
});
export { showless1 as "showLess" }